var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    className: "st0",
    d: "M12.7,6.9C11.5,6.2,10,6.4,9.5,7.4C9,8.2,8.7,9.2,8.7,9.7s-5,29.4-5.2,31.1c0,1,0.2,1.7,1,2.2 c0.5,0.5,1.2,0.5,1.7,0.5c1.2-0.2,36.4-9.5,38.4-9.7c0.5,0,1.2-0.5,1.5-1c0.7-1,0.5-2.5-0.5-3.3C44.1,28.3,14.5,8.2,12.7,6.9  M11.2,19.4c0.7-2.5,0.7-4.2,1.5-5.2c0.5-0.7,1.5-1,2.2-0.5c1.2,1,1.5,3.5,0.5,5.5s-8,16.2-8,16.2S9.5,25.6,11.2,19.4 M36.2,28.6 c0,0.2,0,0.5-0.2,0.7c-0.5,0.5-1.2,1-2,1.2c-0.7,0.2-21.2,8.2-22,8.5c-0.7,0.2-2.2,1-2.8,0.5C8.5,39.1,9,38.1,9.5,37 c2-3,9.5-14.2,10.2-15.7c1.2-1.7,3.3-2.5,5-1.2c2,1.5,10,7,10.5,7.2C35.7,27.9,36.2,28.1,36.2,28.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriosLogo);
export default __webpack_public_path__ + "static/media/trios_logo.6a0de75156b1253e4cd673437ac52178.svg";
export { ForwardRef as ReactComponent };